import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DetailRepository from "../Repositories/DetailRepository";

class Detailloc {
  rowtableChannel = new Subject();
  workUnitChannel = new Subject();
  listAtasanChannel = new Subject();
  exportChannel = new Subject();
  detailChannel = new Subject();
  repository = new DetailRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.listAtasanChannel.next({ status: apiResponse.INITIAL });
    this.exportChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
  }

  fetchDetail = async (query, cancelToken) => {
    this.detailChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchDetail(query, cancelToken)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };
  fetchRowTable = async (query, cancelToken) => {
    this.rowtableChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchWorkUnit = async (query, cancelToken) => {
    this.workUnitChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchWorkUnit(query, cancelToken)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchAtasan = async (query, cancelToken) => {
    this.listAtasanChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchAtasan(query, cancelToken)
        .then((result) => {
          this.listAtasanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listAtasanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchExport = async (query) => {
    try {
      this.exportChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExport(query)
        .then((result) => {
          this.exportChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };
}

export default Detailloc;
